// extracted by mini-css-extract-plugin
export default {"content_section":"S1_BillSavings_content_section__PVNKw","best_fit_savings_line":"S1_BillSavings_best_fit_savings_line__uAslL"};